
<ion-grid class="amplify-ionic-grid-padding-left">
    <ion-row>
        <ion-col size="6" class="amplify-ionic-grid-padding-left">
            <ion-label class="amplify-input-label push-right"
                position="stacked" 
                for="localPhoneNumberField">
                {{ this.amplifyService.i18n().get(this._label) }}
                <span *ngIf="_required">*</span>
            </ion-label>
            <ion-select 
            #countryCodeField
            name="countryCode"
            class="amplify-select-phone-country"
            [value]="_country_code"
            (ionChange)="setCountryCode($event.target.value)"
            data-test="dial-code-select">
            <ion-select-option *ngFor="let country of _countries"
            value={{country.value}}>
                {{country.label}}
            </ion-select-option>
            </ion-select>
        </ion-col>
        <ion-col size="6">
            <ion-label class="amplify-input-label push-right">&nbsp;</ion-label>
            <ion-input
            #localPhoneNumberField
            class="amplify-form-input-phone-ionic"
            placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
            name="local_phone_number"
            type="tel"
            (ionChange)="setLocalPhoneNumber($event.target.value)"
            data-test="phone-number-input"
            ></ion-input>
        </ion-col>
    </ion-row>
</ion-grid>